import { useEffect } from 'react';

export function useAsyncEffect(cb: () => Promise<unknown>, dependencies: any[] = []) {
  useEffect(() => void cb(), dependencies);
}
